exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".element_options[data-v-2eff7308] {\n  margin-bottom: 10px;\n}\n.element_input[data-v-2eff7308] {\n  width: 90%;\n}\n", ""]);

// exports
